import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { ResponseFailModal } from '../../modal/Response';
import { SMSSend } from '../../SMSSend';
import Spin from '../../Spin';
import countryInfo from '../../../assets/countries.json';
import * as api from '../../../api';
import moment from 'moment';

const UserkeyIssue = ({
  isOpen,
  toggle,
  reload,
  bookingId,
  roomName,
}) => {
  // const hotelId = localStorage.getItem('hotel_id');
  const { t } = useTranslation();
  const keyTypeList = [
    { key: t('data.key_type.pincode'), value: 'pincode' },
    { key: t('data.key_type.mobilekey'), value: 'mobilekey' },
  ];
  const pincodeTypeV2List = [
    { key: t('data.pincode_type.day'), value: 'day' },
    { key: t('data.pincode_type.hour'), value: 'hour' },
    { key: t('data.pincode_type.min'), value: '10mins' },
  ];
  const pincodeTypeV3List = [
    { key: t('data.pincode_type.hour'), value: 'hour' },
  ];
  const howToIssueV2List = [
    { key: t('data.issue_type.copy'), value: false },
    { key: t('data.issue_type.new'), value: true },
  ];
  const howToIssueList = [
    { key: t('data.issue_type.copy'), value: false },
  ];

  const countryInfoList = Object.values(countryInfo);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ countryNumber, setCountryNumber ] = useState('82');
  // const [ pincodeDayTypeOffset, setPincodeDayTypeOffset ] = useState('');
  const [ isOpenKeyIssueSuccessModal, setIsOpenKeyIssueSuccessModal ] = useState(false);
  const [ isOpenKeyIssueFailModal, setIsOpenKeyIssueFailModal ] = useState(false);
  const [ messageKeyIssueFail, setMessageKeyIssueFail ] = useState('');
  const [ selectedKeyType, setSelectedKeyType ] = useState('pincode');
  const [ bookingItem, setBookingItem ] = useState({
    checkinAt: '',
    checkoutAt: '',
  });
  const [ limitCheckInOutAt, setLimitCheckInOutAt ] = useState({
    minCheckinAt: '',
    maxCheckoutAt: '',
  });
  const [ keyIssueItem, setKeyIssueItem ] = useState({
    userName: '',
    phoneNumber: '',
    type: 'day',
    isNew: false,
    checkinAt: '',
    checkoutAt: '',
  });
  const [ SMSSendItem, setSMSSendItem ] = useState({
    type: '',
    value: '',
    keyId: '',
  });
  const [ roomUpdateItem, setRoomUpdateItem ] = useState({
    roomId: '',
    name: '',
    floorId: '',
    rmsId: '',
    allowKeytag: '',
    advertiseStrength: '',
    connectedStrength: '',
    status: '',
    buildingName: '',
    floorName: '',
    createdAt: '',
    updatedAt: '',
    doorlock: {
      doorlockId: '',
      dlSerial: '',
      name: '',
      pincodeVersion: '',
    },
  });  
  const [ hotelUpdateItem, setHotelUpdateItem ] = useState({
    name: '',
    timezone: '',
    address: '',
    desc: '',
    pincodeVersion: '',
    pincodeLength: '',
    pincodeDayTypeOffset: '',
    allowInfinityPincode: '',
    pincodeAuthTimeoutMin: '',
    useSlimkey: '',
    commonrooms: '',
    notifyChannelId: '',
    apphotelstory: '',
    appElevatorBtn: '',
    doorlockDeletable: '',
    role: '',
    notifyEmail: '',
  });
  const checkinAtV4HH = Array.from({length: 23}, (v,i)=> i+1);
  const checkinAtV4MM = Array.from({length: 59}, (v,i)=> i+1);
  const [hourV4, setHourV4] = useState('');
  const [minuteV4, setMinuteV4] = useState('');

  const validateStartAt = (time) => {
    const selectedDate = new Date(time);
    return (limitCheckInOutAt.minCheckinAt.getTime() <= selectedDate.getTime()) && (selectedDate.getTime() < limitCheckInOutAt.maxCheckoutAt.getTime());
  }

  const validateEndAt = (time) => {
    const selectedDate = new Date(time);
    return (limitCheckInOutAt.minCheckinAt.getTime() < selectedDate.getTime()) && (selectedDate.getTime() <= limitCheckInOutAt.maxCheckoutAt.getTime());
  }

  const changeKeyStartAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkinAt: date,
    });
  };

  const changeKeyEndAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkoutAt: date,
    });
  };

  const changeKeyStartAt2 = (date) => {
    const value = date < limitCheckInOutAt.minCheckinAt? limitCheckInOutAt.minCheckinAt : date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkinAt: value,
    });
  };

  const changeKeyEndAt2 = (date) => {
    const value = date > limitCheckInOutAt.maxCheckoutAt? limitCheckInOutAt.maxCheckoutAt : date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      checkoutAt: value,
    });
  };

  const changeKeyType = (keyType) => {
    setSelectedKeyType(keyType);
    if (keyType === 'mobilekey')
      setKeyIssueItem({
        ...keyIssueItem,
        checkinAt: limitCheckInOutAt.minCheckinAt,
        checkoutAt: limitCheckInOutAt.maxCheckoutAt,
      });
    else changePincodeType('day');
  };

  const changePincodeType = (pincodeType) => {
    switch (pincodeType) {
      case 'day':
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt: limitCheckInOutAt.maxCheckoutAt,
        });
      case 'hour':
        const add1Days = addDays(limitCheckInOutAt.minCheckinAt, 1);
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt: add1Days > limitCheckInOutAt.maxCheckoutAt ?
            limitCheckInOutAt.maxCheckoutAt : add1Days,
        });
      case '10mins':
        const add5Hours = addHours(limitCheckInOutAt.minCheckinAt, 5);
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: limitCheckInOutAt.minCheckinAt,
          checkoutAt: add5Hours > limitCheckInOutAt.maxCheckoutAt ?
            limitCheckInOutAt.maxCheckoutAt : add5Hours,
        });
      default:
        return setKeyIssueItem({
          ...keyIssueItem,
          type: pincodeType,
          checkinAt: '',
          checkoutAt: '',
        });
    }
  };

  const setTimeInterval = () => {
    const formatter = {
      'day': 60,
      'hour': 60,
      '10mins': 10,
    };
    return formatter[keyIssueItem.type] || 60;
  };

  const issueKey = async () => {
    try {
      setIsLoading(true);
      const reqNum = countryNumber + Number.parseInt(keyIssueItem.phoneNumber);
      if (selectedKeyType === 'mobilekey') await issueUserMobilekey(reqNum);
      else await issueUserPincode(reqNum);
      setIsOpenKeyIssueSuccessModal(true);
    } catch (error) {
      if (!error.response) setMessageKeyIssueFail(error.message);
      else setMessageKeyIssueFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenKeyIssueFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const issueUserMobilekey = async (phoneNumber) => {
    try {
      const res = await api.issueUserMobilekey({bookingId, ...keyIssueItem, phoneNumber});
      setSMSSendItem({
        ...SMSSendItem,
        type: 'mobilekey',
        value: res.data.exchangekey,
        keyId: res.data.user_id,
      });
    } catch (error) {
      throw error;
    }
  };

  const issueUserPincode = async (phoneNumber) => {
    try {
      const res = await api.issueUserPincode({bookingId, ...keyIssueItem, phoneNumber});
      setSMSSendItem({
        ...SMSSendItem,
        type: 'pincode',
        value: res.data.pincode,
        keyId: res.data.pincode_id,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleSelectRoom = async (selectedBuildingId, selectRoomId) => { 
    try {
      const res = await api.selectRoomId({buildingId: selectedBuildingId, roomId : selectRoomId});
      setRoomUpdateItem({
        roomId: res.data.id,
        name: res.data.name,
        floorId: res.data.floor_id,
        rmsId: res.data.rms_id,
        allowKeytag: res.data.allow_keytag,
        advertiseStrength: res.data.advertise_strength,
        connectedStrength: res.data.connected_strength,
        status: res.data.status,
        buildingName: res.data.building_name,
        floorName: res.data.floor_name,
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
        doorlock: {
          doorlockId: res.data.doorlock.id,
          dlSerial: res.data.doorlock.dl_serial,
          name: res.data.doorlock.name,
          pincodeVersion: res.data.doorlock.pincode_version,
        },
      });
    } catch (error) {
      throw error;
    }
  };

  const hnadleChangeHHV4 = (e) => {
    const { value } = e.target;

    setHourV4(value);
  }
  const hnadleChangeMMV4 = (e) => {
    const { value } = e.target;

    setMinuteV4(value);
  }

  const selectHotel = async () => {
    try {
      setIsLoading(true);
      const res = await api.selectHotel();
      setHotelUpdateItem({
        name: res.data.name,
        timezone: res.data.timezone,
        address: res.data.address,
        desc: res.data.desc,
        pincodeVersion: res.data.pincode_version,
        pincodeLength: res.data.pincode_length,
        pincodeDayTypeOffset: res.data.pincode_day_type_offset,
        allowInfinityPincode: res.data.allow_infinity_pincode,
        pincodeAuthTimeoutMin: res.data.pincode_auth_timeout_min,
        useSlimkey: res.data.use_slimkey,
        commonrooms: res.data.commonrooms,
        notifyChannelId: res.data.notify_channel_id,
        apphotelstory: res.data.app_hotelstory,
        appElevatorBtn: res.data.app_elevator_btn,
        doorlockDeletable: res.data.doorlock_deletable,
        role: res.data.role,
        notifyEmail: res.data.notify_email,
      });
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    selectHotel();
  },[]);

  useEffect(() => {
    const selectBooking = async () => {
      try {
        setIsLoading(true);
        const res = await api.selectBooking({bookingId});
        setKeyIssueItem({
          userName: res.data.user.name,
          phoneNumber: res.data.user.phone_number ? res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '0$2'):'',
          type: 'day',
          isNew: false,
          checkinAt: new Date(res.data.checkin_at),
          checkoutAt: new Date(res.data.checkout_at),
        });
        if (res.data.user.phone_number) setCountryNumber(res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '$1'));
        setLimitCheckInOutAt({
          minCheckinAt: new Date(res.data.checkin_at),
          maxCheckoutAt: new Date(res.data.checkout_at),
        });
        setBookingItem({
          checkinAt: new Date(res.data.checkin_at),
          checkoutAt: new Date(res.data.checkout_at),
        })
        setHourV4(moment(res.data.checkin_at).hour() > 9? moment(res.data.checkin_at).hour() : `0${moment(res.data.checkin_at).hour()}`);
        setMinuteV4(moment(res.data.checkin_at).minute() > 9?  moment(res.data.checkin_at).minute() : `0${moment(res.data.checkin_at).minute()}`);
        handleSelectRoom(res.data.building.id, res.data.room.id);
      } catch (error) {
        throw error;
      } finally {
        setIsLoading(false);
      }
    };
    if (bookingId) selectBooking();
  }, [bookingId, isOpen]);

  useEffect(() => {
    const init = () => {
      setSelectedKeyType('pincode');
      setSMSSendItem({
        type: '',
        value: '',
        keyId: '',
      });
    };
    init();
  }, [isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>{t('content_title.key_issue')}</h4>
            </div>
            <div className='inline-flex'>
              <div className='w-100'>
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faKey}/> */}
                    <b>{t('data_column.key_type')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={selectedKeyType}
                    onChange={e => changeKeyType(e.target.value)}
                  >
                    {keyTypeList.map((keyType, index) => (
                      <option key={index} value={keyType.value}>{keyType.key}</option>
                    ))}
                  </select>
                </div>
                <div className='card-text' hidden={selectedKeyType !== 'pincode' || roomUpdateItem.doorlock.pincodeVersion === 'V4'}>
                  <p>
                    {/* <FontAwesomeIcon icon={faTag}/> */}
                    <b>{t('data_column.pincode_type')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={keyIssueItem.type}
                    onChange={e => changePincodeType(e.target.value)}
                  >
                    {roomUpdateItem.doorlock.pincodeVersion === 'V3'? 
                      pincodeTypeV3List.map((type, index) => (
                        <option key={index} value={type.value}>{type.key}</option>
                      ))
                    : 
                      pincodeTypeV2List.map((type, index) => (
                        <option key={index} value={type.value}>{type.key}</option>
                      ))
                    }
                  </select>
                </div>


            {/* 핀코드 V4 일 경우 */}
            {roomUpdateItem.doorlock.pincodeVersion === 'V4' && selectedKeyType === 'pincode' && <>
              <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                    <b>{t('data_column.start_at')}</b>
                    <span className='required'>*</span>
                  </p>
                <div className='card-text-date-V4'>
                  <DatePicker
                    disabled={selectedKeyType === 'pincode' && !keyIssueItem.type}
                    dateFormat='yyyy-MM-dd'
                    placeholderText={t('placeholder.start_at')}
                    selected={keyIssueItem.checkinAt}
                    selectsStart
                    minDate={limitCheckInOutAt.minCheckinAt}
                    maxDate={limitCheckInOutAt.maxCheckoutAt}
                    endDate={keyIssueItem.checkoutAt}
                    showTimeSelect={false}
                    filterTime={validateStartAt}
                    timeFormat='HH:mm'
                    timeIntervals={setTimeInterval()}
                    timeCaption='Time'
                    onChange={date => changeKeyStartAt2(date)}
                    withPortal
                    style={{marginRight: '1rem'}}
                  />
                  
                  <select 
                    className='card-text-select' 
                    name='checkinAt-hh' 
                    onChange={e => hnadleChangeHHV4(e)} 
                    value={hourV4}
                  >
                    <option value='00'>00</option>
                    {checkinAtV4HH.map((value, index) => {
                      const hh_value = value > 9? value : `0${value}`;
                      return <option key={hh_value} value={hh_value}>{hh_value}</option>
                      })}
                  </select>
                  <select 
                    className='card-text-select'
                    name='checkinAt-mm' 
                    onChange={e => hnadleChangeMMV4(e)} 
                    value={minuteV4}
                  >
                    <option value='00'>00</option>
                    {checkinAtV4MM.map((value, index) => {
                      const mm_value = value > 9? value : `0${value}`;
                      return <option key={mm_value} value={mm_value}>{mm_value}</option>
                      })}
                  </select>
                  </div>
                </div>
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                    <b>{t('data_column.end_at')}</b>
                    <span className='required'>*</span>
                  </p>
                  <DatePicker
                    disabled={!keyIssueItem.checkinAt}
                    dateFormat='yyyy-MM-dd HH:mm'
                    placeholderText={t('placeholder.end_at')}
                    selected={keyIssueItem.checkoutAt}
                    selectsEnd
                    minDate={limitCheckInOutAt.minCheckinAt}
                    maxDate={limitCheckInOutAt.maxCheckoutAt}
                    startDate={keyIssueItem.checkinAt}
                    showTimeSelect={false}
                    filterTime={validateEndAt}
                    timeFormat='HH:mm'
                    timeIntervals={setTimeInterval()}
                    timeCaption='Time'
                    onChange={date => changeKeyEndAt2(date)}
                    withPortal
                  />
                </div>
            </>}
            {/* 핀코드 V4가 아닐 경우 */}
            {(roomUpdateItem.doorlock.pincodeVersion !== 'V4' || selectedKeyType !== 'pincode') && <>
             
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassStart}/> */}
                    <b>{t('data_column.start_at')}</b>
                    <span className='required'>*</span>
                  </p>
                  <DatePicker
                    disabled={selectedKeyType === 'pincode' && !keyIssueItem.type}
                    dateFormat='yyyy-MM-dd HH:mm'
                    placeholderText={t('placeholder.start_at')}
                    selected={keyIssueItem.checkinAt}
                    selectsStart
                    minDate={limitCheckInOutAt.minCheckinAt}
                    maxDate={limitCheckInOutAt.maxCheckoutAt}
                    endDate={keyIssueItem.checkoutAt}
                    showTimeSelect
                    filterTime={validateStartAt}
                    timeFormat='HH:mm'
                    timeIntervals={setTimeInterval()}
                    timeCaption='Time'
                    onChange={date => changeKeyStartAt(date)}
                    withPortal
                  />
                </div>
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faHourglassEnd}/> */}
                    <b>{t('data_column.end_at')}</b>
                    <span className='required'>*</span>
                  </p>
                  <DatePicker
                    disabled={!keyIssueItem.checkinAt}
                    dateFormat='yyyy-MM-dd HH:mm'
                    placeholderText={t('placeholder.end_at')}
                    selected={keyIssueItem.checkoutAt}
                    selectsEnd
                    minDate={limitCheckInOutAt.minCheckinAt}
                    maxDate={limitCheckInOutAt.maxCheckoutAt}
                    startDate={keyIssueItem.checkinAt}
                    showTimeSelect
                    filterTime={validateEndAt}
                    timeFormat='HH:mm'
                    timeIntervals={setTimeInterval()}
                    timeCaption='Time'
                    onChange={date => changeKeyEndAt(date)}
                    withPortal
                  />
                </div>
              </>}

                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faUserAlt}/> */}
                    <b>{t('data_column.user_name')}</b>
                    <span className='required'>*</span>
                  </p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.user_name')}
                    value={keyIssueItem.userName}
                    onChange={e => setKeyIssueItem({...keyIssueItem, userName:e.target.value})}
                  />
                </div>
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faPhone}/> */}
                    <b>{t('data_column.key_type')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={countryNumber}
                    onChange={e => setCountryNumber(e.target.value)}
                  >
                    {countryInfoList.map((country, index) => (
                      <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                    ))}
                  </select>
                  <p></p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.phone_number')}
                    value={keyIssueItem.phoneNumber}
                    maxLength='11'
                    onChange={e => setKeyIssueItem({...keyIssueItem, phoneNumber:e.target.value})}
                  />
                </div>
                <div className='card-text'>
                  <p>
                    {/* <FontAwesomeIcon icon={faBookOpen}/> */}
                    <b>{t('data_column.issue_type')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={keyIssueItem.isNew}
                    onChange={e => setKeyIssueItem({...keyIssueItem, isNew:e.target.value})}
                  >
                    {roomUpdateItem.doorlock.pincodeVersion === 'V2' || selectedKeyType === 'mobilekey'? 
                    howToIssueV2List.map((howToIssue, index) => (
                      <option key={index} value={howToIssue.value}>{howToIssue.key}</option>
                    ))
                    :
                    howToIssueList.map((howToIssue, index) => (
                      <option key={index} value={howToIssue.value}>{howToIssue.key}</option>
                    ))
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className='card-foot'>
            <div className='form-item-cancel'>
              <button className='btn-item-cancel' onClick={() => toggle()}>
                <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
              </button>
            </div>
            <div className='form-item-add center'>
              <button className='btn-item-add' onClick={issueKey}>
                <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <SMSSend
        isOpen={isOpenKeyIssueSuccessModal}
        toggle={() => setIsOpenKeyIssueSuccessModal(!isOpenKeyIssueSuccessModal)}
        smsSendItem={{...SMSSendItem, bookingId}}
        reload={() => {
          reload();
          toggle();
        }}
      />
      <ResponseFailModal
        isOpen={isOpenKeyIssueFailModal}
        toggle={() => setIsOpenKeyIssueFailModal(!isOpenKeyIssueFailModal)}
        message={messageKeyIssueFail || t('error_message.issue_key')}
      />
    </Fragment>
  );
};

export default UserkeyIssue;